import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { CoreConfigService } from '@core/services/config.service';
import { LoginService } from 'app/services/auth/login.service';
import { AppShellLayoutService } from 'app/services/layout/app-shell-layout.service';
import { LogicielCaisseAuthService } from 'app/services/logiciel-caisse/logiciel-caisse-auth.service';
import { setConnectedEnterpriseStationId } from 'app/services/enterprise-context';

@Component({
  selector: 'app-create-station',
  templateUrl: './create-station.component.html',
  styleUrls: ['./create-station.component.scss']
})
export class CreateStationComponent implements  OnInit {
  displayPassword="password";
  public coreConfig: any;
  public loginForm: UntypedFormGroup;
  public loading = false;
  public submitted = false;
  public returnUrl: string;
  public error = '';
  data:any={ 
    titre:"",
    nb_employer:"",
    type:"",

    
  }
  dataError:any={
          titre:"",
          nb_employer:"",
          type:"",
       
  }
   stationTypes = [
    'Type 1', 'Type 2', 'Type 3', 'Type 4', 'Type 5',
    'Type 6', 'Type 7', 'Type 8', 'Type 9', 'Type 10',
    'Type 11', 'Type 12', 'Type 13', 'Type 14', 'Type 15',
    'Type 16', 'Type 17', 'Type 18', 'Type 19', 'Type 20',
    'Type 21', 'Type 22', 'Type 23', 'Type 24', 'Type 25',
    'Type 26', 'Type 27', 'Type 28', 'Type 29', 'Type 30'
  ];
  countdown: number = 60;
interval: any;
canResend: boolean = false;
  validate=false;
  public passwordTextType: boolean;
errorMessage:any="";
  // Private
  private _unsubscribeAll: Subject<any>;

  /**
   * Constructor
   *
   * @param {CoreConfigService} _coreConfigService
   */
  constructor(
    private loginService:LoginService,
    private _coreConfigService: CoreConfigService,
    private _formBuilder: UntypedFormBuilder,
    private _route: ActivatedRoute,
    private _router: Router,
    private _appShellLayout: AppShellLayoutService,
    private _logicielCaisseAuth: LogicielCaisseAuthService
  ) {
    this._unsubscribeAll = new Subject();

    // Configure the layout
    this._coreConfigService.config = {
      layout: {
        navbar: {
          hidden: true
        },
        menu: {
          hidden: true
        },
        footer: {
          hidden: true
        },
        customizer: false,
        enableLocalStorage: false
      }
    };
  }

 

 
 

  
  ngOnInit(): void {
    this.loginForm = this._formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required]
    });
    this.returnUrl = this._route.snapshot.queryParams['returnUrl'] || '/';
    this._coreConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe(config => {
      this.coreConfig = config;
    });
     
  }
   create() {
    
    if (!this.validates()) {
      return;
    }
     let user = localStorage.getItem('currentUser');
  let users = JSON.parse(user);
    this.data.user = users.id;
    const onboardingPassword =
      sessionStorage.getItem('registration_onboarding_password') || '';
    if (onboardingPassword.length >= 6) {
      this.data.password = onboardingPassword;
    }
    this.loading = true;
   this.loginService.createStation(this.data).subscribe({
            next: (data) => {
                if(data.user)
                {
                    localStorage.setItem('currentUser', JSON.stringify(data.user));
                    const titre = String(this.data.titre || '').trim();
                    const createdStationId = this.resolveCreatedStationId(data.user, titre);
                    if (createdStationId > 0) {
                      setConnectedEnterpriseStationId(createdStationId, {
                        label: titre,
                        nom_entreprise: titre,
                      });
                    }
                    if (titre) {
                      localStorage.setItem('registration_nom_entreprise', titre);
                    }
                    const pwd =
                      this.data.password ||
                      sessionStorage.getItem('registration_onboarding_password') ||
                      '';
                    const email = String(data.user.email || users.email || '').trim();
                    const finish = () => {
                      sessionStorage.removeItem('registration_onboarding_password');
                      this._appShellLayout.restoreAfterAuthPages();
                      this._router.navigate(['/home']);
                      this.loading = false;
                    };
                    if (pwd.length >= 6 && email) {
                      this._logicielCaisseAuth
                        .authenticateAfterErpLogin(email, pwd)
                        .subscribe({
                          next: () => finish(),
                          error: () => finish(),
                        });
                      return;
                    }
                    finish();
                  
                }
                this.loading = false;
            },
            error: (err) => {
              this.errorMessage =
                err?.error?.error ||
                err?.error?.logiciel_caisse?.error ||
                'Création impossible. Vérifiez que le backend logiciel caisse est accessible.';
              this.loading = false;
            },
          });
  }

  validates() {
    this.dataError.titre = this.data.titre.trim() ? '' : 'Le nom de l\'entreprise est obligatoire';
    this.dataError.nb_employer = this.data.nb_employer ? '' : 'Veuillez choisir un nombre d\'employés';
   

    return !this.dataError.titre && !this.dataError.nb_employer && !this.dataError.type;
  }

  /** Id station ERP nouvellement créée (pas `stations[0]`). */
  private resolveCreatedStationId(user: { stations?: unknown[] }, titre: string): number {
    const stations = Array.isArray(user?.stations) ? user.stations : [];
    const wanted = titre.trim().toLowerCase();
    for (const raw of stations) {
      if (raw == null || typeof raw !== 'object') {
        continue;
      }
      const s = raw as Record<string, unknown>;
      const label = String(s['label'] ?? s['nom_entreprise'] ?? '').trim().toLowerCase();
      const id = Number(s['id'] ?? s['station_id']);
      if (wanted && label === wanted && Number.isFinite(id) && id > 0) {
        return Math.floor(id);
      }
    }
    if (stations.length === 0) {
      return 0;
    }
    const last = stations[stations.length - 1] as Record<string, unknown>;
    const fallback = Number(last['id'] ?? last['station_id']);
    return Number.isFinite(fallback) && fallback > 0 ? Math.floor(fallback) : 0;
  }





}